export const TIMEOUT = 20000
export const TERMS_ADAPTER = {
  /* Original from API */
  typeApproach: 'typeApproach',
  typeIssues: 'typeIssues',
  typeIssue: 'typeIssues',
  typeOrganisasi: 'typeOrganisasi',
  typeAudience: 'typeAudience',
  typeResource: 'typeResource',
  kategoriArtikel: 'kategoriArtikel',
  limit: 'limit',
  offset: 'offset',
  title: 'title',
  sortbycreatedat: 'sortbycreatedat',
  sortbynamaorganisasi: 'sortbynamaorganisasi',
  sortbyjudulcontent: 'sortbyjudulcontent',
  provinsi: 'provinsi',
  kota: 'kota',
  startRentangWaktu: 'startRentangWaktu',
  endRentangWaktu: 'endRentangWaktu',
  organization: 'organization',
  submission: 'submission',
  progress: 'progress',

  // Adapted by frontend, for naming consistency
  approach: 'typeApproach',
  issue: 'typeIssues',
  type: 'typeOrganisasi',
  audience: 'typeAudience',
  category: 'kategoriArtikel',
  keyword: 'title',
  province: 'provinsi',
  city: 'kota',
  date: 'sortbycreatedat',
  name: 'sortbynamaorganisasi',
  sort_by_title: 'sortbyjudulcontent'
}

export const SPECIAL_FIELD_ADAPTER = {
  approach: 'Type_Approach',
  issue: 'Type_Issues',
  organizationType: 'Type_Organisasi',
  audience: 'Type_Audience',
  link: 'Kategori_Sosial_Media',
  resourceType: 'Type_Resources',
  categories: 'Kategori_Artikel',
  submission: 'Submission',
  activityStatus: 'Status_Activity',
  gender: 'Type_Gender',
  disability: 'Type_Difable',
  channel: 'Type_Channel',
  typeResources: 'Type_Resources'
}

export const QUERY_BLACKLIST = [
  "date",
  "name",
  "limit",
  "offset",
  "page",
  "collection",
  "sort_by_title",
  "organization",
  "progress"
];

// Key: Frontend Terms, Value: API Terms.
export const ROLE_ADAPTER = {
  official: 2,
  verified: 1,
  user: 1
}

export const provinceFirstLabel = {
  en: 'Please select province first.',
  id: 'Pilih provinsi terlebih dahulu.'
}

export const submissionStatus = {
  underReview: 1,
  draft: 2,
  needRevision: 3,
  approved: 4,
  trash: 5,
  declined: 6
}

export const activityStatus = {
  cancelled: 5,
}

export const EMAIL = 'k-hub@peacegen.id'
export const WHATSAPP = '62816962179'

export const PDFInfoText = {
  en: 'These reports are automatically generated from the Knowledge Hub (K-Hub) Platform',
  id: 'Laporan ini secara otomatis dibuat dari Platform Pusat Pengetahuan (K-Hub)'
}

// A: All content is private, except all visibility field is set to public
// B: All content is public, except no visibility field is set to public
export const CONTENT_DETAIL_SYSTEM = 'B'
